/**
 * Chart theme colors for dark/light mode support.
 * Used by ApexCharts components for foreColor, grid, tooltip HTML, etc.
 */

export function getChartThemeColors(isDark: boolean) {
  return {
    foreColor: isDark ? '#A1A1AA' : '#71717A',
    gridBorderColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
    gridRowColors: isDark
      ? ['rgba(255,255,255,0.03)', 'transparent']
      : ['#f3f3f3', 'transparent'],
    tooltipBg: isDark ? '#1a1a2e' : '#f8f9fa',
    tooltipTitle: isDark ? '#ECEDEE' : '#333333',
    tooltipText: isDark ? '#A1A1AA' : '#666666',
    tooltipValue: isDark ? '#ECEDEE' : '#000000',
    tooltipBorder: isDark ? '#2a2a3e' : '#eee',
    tooltipShadow: isDark
      ? '0 2px 4px rgba(0,0,0,0.4)'
      : '0 2px 4px rgba(0,0,0,0.1)',
    tableBg: isDark ? '#18181b' : '#ffffff',
    tableHeaderBg: isDark ? '#27272a' : '#f9fafb',
    tableStripeBg: isDark ? '#1f1f23' : '#f3f3f3',
  };
}

export function tooltipContainerStyle(isDark: boolean): string {
  const c = getChartThemeColors(isDark);
  return `
    background-color: ${c.tooltipBg};
    border-radius: 8px;
    box-shadow: ${c.tooltipShadow};
    padding: 12px;
    font-family: Arial, sans-serif;
  `;
}

export function tooltipTitleStyle(isDark: boolean): string {
  const c = getChartThemeColors(isDark);
  return `text-align: center; font-size: 16px; font-weight: bold; color: ${c.tooltipTitle};`;
}

export function tooltipLabelStyle(isDark: boolean): string {
  const c = getChartThemeColors(isDark);
  return `color: ${c.tooltipText};`;
}

export function tooltipValueStyle(isDark: boolean): string {
  const c = getChartThemeColors(isDark);
  return `font-weight: bold; color: ${c.tooltipValue}; margin-left: 10px;`;
}
